// extracted by mini-css-extract-plugin
export default {"container":"Title_container__35fT3","imgPosition":"Title_imgPosition__Xyqrr"};